import { Language, useLanguageStore } from "~/stores/language-store";

export type BookableItemTag = {
    id: string;
    labelDe: string;
    labelEn: string;
    color: string;
};

// Mirrors the BookingFunnelTagColor enum in the server's prisma schema
const TAG_COLOR_CLASSES: Record<string, string> = {
    BURGUNDY: 'bg-burgundy text-white',
    ROSE: 'bg-[#F2D5DB] text-[#561C2C]',
    GREEN: 'bg-[#D8E8DC] text-[#2E5A3B]',
    BLUE: 'bg-[#D6E3F0] text-[#274B6D]',
    AMBER: 'bg-[#F8E3C0] text-[#7A4E12]',
    PURPLE: 'bg-[#E3D8EE] text-[#4C3268]',
    GRAY: 'bg-[#E5E3E0] text-dark',
    NAVY: 'bg-[#30304A] text-white',
    ORANGE: 'bg-[#FF6439] text-white',
    PEACH: 'bg-[#F0C5A6] text-[#7A3E1C]',
    SAND: 'bg-[#EFE0CD] text-[#6B5232]',
};

const BookableItemTags = ({ tags }: { tags?: BookableItemTag[] }) => {
    const { language } = useLanguageStore();

    if (!tags || tags.length === 0) return null;

    return (
        <div className='flex flex-wrap justify-end gap-1 shrink-0 max-w-[55%]'>
            {tags.map((tag) => (
                <span
                    key={tag.id}
                    className={`inline-flex items-center justify-center rounded-full px-2 py-1 text-center text-[10px] font-medium leading-none whitespace-nowrap ${TAG_COLOR_CLASSES[tag.color] ?? TAG_COLOR_CLASSES.BURGUNDY}`}
                >
                    {language === Language.GERMAN ? tag.labelDe : tag.labelEn}
                </span>
            ))}
        </div>
    );
};

export default BookableItemTags;
